import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/chrislowell.jpg'
import Image2 from '../images/chrislowell-b-154x300.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Christopher Lowell " keywords={[]} />
    <div id="main" role="main">
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 class="page-title">Christopher Lowell</h1>
        <div>
          <img
            src={Image}
            alt="Chris Lowell"
            title="chrislowell"
            width="200"
            height="200"
            class="alignleft size-full wp-image-297"
            style={{ float: 'left' }}
          />
          <p />
          <p>
            A native New Yorker, Mr. Lowell has had a long dual career in the
            classroom and on the stage. A graduate of Dickinson College (PA)
            with a double major in theater and French, and Colgate University
            (NY) with an MA in French literature, he taught French and theater
            for over 40 years and has been an actor since childhood. Lowell has
            twice been honored with “Best Actor of the Year” awards from the
            press in his adopted city of Colorado Springs, where he and his wife
            have lived since 1973, and was honored with the Denver Post’s
            “Ovation Award” for Best Actor in a Dramatic role for the year 2011.
          </p>
          <p>
            Bilingual in French, Mr Lowell taught in France, where he was
            awarded a grant as a Fulbright Exchange Teacher for the academic
            year 1992-93. Then, he taught in Brittany—the region where Ben
            Franklin first touched French soil in December of 1776.
          </p>
          <p>
            <img
              style={{ float: 'right' }}
              src={Image2}
              alt=""
              title="chrislowell-b"
              width="154"
              height="300"
              class="alignright size-medium wp-image-315"
            />
          </p>
          <p>
            Since 2004, Mr. Lowell has brought the extraordinary life and
            accomplishments of Ben Franklin to an ever widening range of
            audiences on a full-time basis, both here and abroad. Along with
            keynote and other presentations to business groups, civic
            organizations, fund-raisers, non-profits, libraries and museums, he
            has presented to students at all levels. In 2007, as a guest of the
            French government, he brought Ben “back” to Paris for the first time
            in 222 years for a series of presentations in French to the French
            diplomatic and business communities. Lowell’s Franklin portrayal has
            been called “the best I have ever seen” by Gordon S. Wood,
            Pulitzer-prize winning historian and author of{' '}
            <u>The Americanization of Benjamin Franklin</u>. Mark Skousen, Ph.d,
            Franklin descendent and author of{' '}
            <u>The Compleated Biography of Benjamin Franklin</u> has called him
            “unequaled.” You can read many similar testimonials on Lowell’s
            LinkedIn page and on his website. There you’ll also find a series of
            one-minute videos of him as Ben.
          </p>
          <p>
            Website:{' '}
            <a href="http://www.benfranklinlive.com/" target="_blank">
              www.benfranklinlive.com
            </a>{' '}
            | Email:{' '}
            <a
              href="mailto:chris@benfranklinlive.com"
              alt="Email Christopher Lowell, MD"
            >
              chris@benfranklinlive.com
            </a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
